const NewsScreen = () => {

    return(
        <p>News Screen</p>
    )

}

export default NewsScreen